import Vue from 'vue'

export var permissions = Vue.observable({
  data: []
})

export function checkPermission(productId, callback) {
  if (!window.goods) return
  window.permissionCallback = result => {
    if (result === true && permissions.data.indexOf(productId) === -1) {
      permissions.data = permissions.data.concat(productId)
      if (callback) {
        callback()
      }
    }
  }
  window.goods.checkPermission(productId, 'permissionCallback')
}

export function hasPermission(productId) {
  return permissions.data.indexOf(productId) !== -1
}
